import {
	overlay,
	hamburgerButton,
	menuPrimary,
	teamWrapper,
	projectDetailsWrapper,
	projectDetails,
} from './elements.js'
import { toggleSection } from './lib.js'
import {
	disableBodyScroll,
	enableBodyScroll,
} from '../../../node_modules/body-scroll-lock/lib/bodyScrollLock.es6.js'

/**
 * Toggle main hamburger menu
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function toggleMenu(e) {
	const expanded =
		hamburgerButton.getAttribute('aria-expanded') === 'true' || false
	const menuState = menuPrimary.getAttribute('data-visible') === 'true' || false

	if (
		e.currentTarget === hamburgerButton ||
		((e.currentTarget === overlay || e.keyCode === 27) && expanded)
	) {
		menuPrimary.setAttribute('data-visible', !menuState)
		overlay.setAttribute('data-visible', !menuState)
		hamburgerButton.setAttribute('aria-expanded', !expanded)

		if (expanded) {
			enableBodyScroll(menuPrimary)
		} else {
			disableBodyScroll(menuPrimary)
		}
	}
}

/**
 * Calculate technical info breakpoint
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function getDetailsBreakpoint() {
	if (projectDetailsWrapper) {
		const projectDetailsWrapperWidth = projectDetailsWrapper.offsetWidth
		const breakNode = projectDetailsWrapper.querySelector('.c-details--break')
		if (breakNode) {
			breakNode.remove()
		}

		let projectDetailsSum = 0
		let panelNeedsBreak = false

		projectDetails.forEach((item) => {
			projectDetailsSum += item.offsetWidth
		})

		if (projectDetailsSum >= projectDetailsWrapperWidth) {
			panelNeedsBreak = true
		}

		if (panelNeedsBreak) {
			projectDetailsSum = 0

			for (let i = 0; i < projectDetails.length; i++) {
				const item = projectDetails[i]
				projectDetailsSum += item.offsetWidth
				if (projectDetailsSum >= projectDetailsWrapperWidth / 2) {
					const newElement = document.createElement('div')
					newElement.classList.add('c-details')
					newElement.classList.add('c-details--break')
					item.parentNode.insertBefore(newElement, item.nextSibling)
					break
				}
			}
		}
	}
}

/**
 * Expand/Collpase info panel
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function toggleProjectInfo(e) {
	const button = e.currentTarget
	const panel = e.currentTarget.nextElementSibling
	const expanded = button.getAttribute('aria-expanded') === 'true' || false

	console.log(panel.id)

	button.setAttribute('aria-expanded', !expanded)
	if (panel.id === 'js-project-details') {
		toggleSection(panel)
	} else {
		panel.setAttribute('data-collapsed', expanded)
	}

	getDetailsBreakpoint()
}

/**
 * Handle card click to make the whole element clickable allowing inside links
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function handleCardClick(e) {
	const isTextSelected = window.getSelection().toString()
	const cardLink = e.target.closest('.js-card').querySelector('.js-main-link')
	const clickableElements = e.target.closest('.js-card').querySelectorAll('a')
	clickableElements.forEach((el) =>
		el.addEventListener('click', (ev) => ev.stopPropagation())
	)
	if (!isTextSelected) {
		cardLink.click()
	}
}

/**
 * Calculate & apply panel position on screen
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
function getPanelPosition(member, panel) {
	const teamWrapperWidth = teamWrapper.clientWidth
	const teamWrapperOffset = teamWrapper.getBoundingClientRect().left
	const memberOffset = member.getBoundingClientRect().left
	const leftOffset = memberOffset - teamWrapperOffset

	panel.style.left = `-${leftOffset}px`
	panel.style.width = `${teamWrapperWidth}px`
}

/**
 * Show/Hide team member description
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 */
export function toggleTeamDescription(e) {
	const button = e.currentTarget
	const panel = button.nextElementSibling
	const member = button.closest('.c-team')
	const expanded = button.getAttribute('aria-expanded') === 'true' || false

	// Change elemen states
	button.setAttribute('aria-expanded', !expanded)
	panel.setAttribute('data-visible', !expanded)
	member.classList.toggle('c-team--focus')
	document.body.classList.toggle('c-body--disable-pointer-events')

	// Calculate description position
	getPanelPosition(member, panel)

	// Re-calculate description position on window resize
	window.addEventListener(
		'resize',
		function (e) {
			getPanelPosition(member, panel)
		},
		{ once: true }
	)
}
